import { Trans } from '@lingui/react'

import {
  useAddNewBankAccountMutation,
  useCheckAllBankAccountsMutation,
} from '@twisto/api-graphql'
import { ButtonGroup, TextButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigBankIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './cash-bank-account-eligibility-step.styles'

export const CashBankAccountEligibilityStep = () => {
  const { sessionId, flow } = useFlow<'CashBankAccountEligibilityStep'>()

  const mutationPayload = {
    variables: {
      auth: {
        sessionId,
      },
    },
  }
  const [addNewBankAccount, { loading: submitingAddAccount }] =
    useAddNewBankAccountMutation()
  const [checkAllBankAccounts, { loading: submittingCheckAccounts }] =
    useCheckAllBankAccountsMutation()
  const submitting = submitingAddAccount || submittingCheckAccounts

  const handleAddNewBankAccount = () => addNewBankAccount(mutationPayload)
  const handleCheckAllBankAccounts = () => checkAllBankAccounts(mutationPayload)

  const currentStep = flow.currentStep

  return (
    <>
      <Headline css={styles.headline}>
        <HeadlineIcon>
          <BigBankIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>{currentStep.heading}</HeadlineTitle>
        {currentStep.textParagraphs.map((paragraph, index) => (
          <HeadlineSubtitle key={index}>{paragraph}</HeadlineSubtitle>
        ))}
      </Headline>
      <ButtonGroup>
        <TextButton
          fullWidth
          disabled={submitting}
          onClick={handleCheckAllBankAccounts}
        >
          <Trans id="flow.cashBankAccountEligibilityStep.button.check" />
        </TextButton>
        <TextButton
          fullWidth
          color="secondary"
          disabled={submitting}
          onClick={handleAddNewBankAccount}
        >
          <Trans id="flow.cashBankAccountEligibilityStep.button.add" />
        </TextButton>
      </ButtonGroup>
    </>
  )
}
